import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { CalendarLtr24Regular, Clock24Regular, Location24Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { FeatureCard } from '@components/common';

const useDemoStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
    flexWrap: 'wrap',
    padding: '1.5rem',
  },
  heading: {
    fontWeight: 600,
    fontSize: fontScale.subtitle,
    color: tokens.colorNeutralForeground1,
    marginBottom: '0.75rem',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '1.5rem',
  },
});

export const FeatureCardDemo = () => {
  const { t } = useTranslation('featureCard');
  const styles = useDemoStyles();

  return (
    <div className={styles.wrapper}>
      <span className={styles.heading}>What you can do</span>
      <div className={styles.container}>
        <FeatureCard
          icon={<CalendarLtr24Regular />}
          title={t('featureCard.bookSpaces.title')}
          description={t('featureCard.bookSpaces.description')}
        />
        <FeatureCard
          icon={<Clock24Regular />}
          title={t('featureCard.trackStatus.title')}
          description={t('featureCard.trackStatus.description')}
        />
        <FeatureCard
          icon={<Location24Regular />}
          title={t('featureCard.multipleLocations.title')}
          description={t('featureCard.multipleLocations.description')}
        />
      </div>
    </div>
  );
};

FeatureCardDemo.displayName = 'FeatureCardDemo';
